
import store from '@/store/store';

export default function getSocieteInitial(societeId) {
  const societes = store.getters['societe/societes'];
  const findSociete = societes.find(s => s.id === societeId);
  if (!findSociete) return;
  const mots = findSociete.libelle.split(' ');
  return (mots.length === 1)
    ? mots
    : mots.map(mot => mot.charAt(0)).join('');
}
